export default __webpack_public_path__ + "static/media/piano-solo.12248810.jpg";